module.exports = __webpack_public_path__ + "media/audio7.12f05629.mp3";